/* The app's loading animation.
 *
 * One component so every waiting state shows the same thing. Each page used to reach for
 * antd's <Spin> directly, which meant the mark changed depending on which screen you
 * happened to be waiting on.
 *
 * ── WHY A COMPONENT AND NOT JUST THE JSON ──
 * lottie-react has to be handed the parsed animation and a size, and a Lottie with no
 * explicit box renders at its native 1080x1080 - which on the board view filled the page
 * and pushed everything below it off screen. Fixing that once here is the point.
 */
import React from "react";
import Lottie from "lottie-react";
import animation from "../../../assets/loading.json";
import "./LoadingAnimation.css";

/* The drawn size in px. The source is a 1080-square, so this is purely how big it is
   asked to draw - large for a page that is otherwise empty, small inside a dialog. */
const SIZES = { small: 56, medium: 88, large: 120 };

export default function LoadingAnimation({ size = "medium", text, className = "" }) {
  const px = SIZES[size] || SIZES.medium;

  return (
    <div className={`loading-animation${className ? ` ${className}` : ""}`}>
      {/* style rather than width/height props: lottie-react passes those to the wrapper
          div, and the SVG inside still needs the box to size against. */}
      <Lottie animationData={animation} loop autoplay style={{ width: px, height: px }} />
      {text ? <span className="loading-animation-text">{text}</span> : null}
    </div>
  );
}
